import {
    GET_ACCOUNT_ALERTS_FAILED,
    GET_ACCOUNT_ALERTS_PENDING,
    GET_ACCOUNT_ALERTS_FULFILLED,
    GET_CONTACT_PREFERENCES_FULFILLED,
    UPDATE_ALERT_BANKING_FULFILLED,
    UPDATE_DELIVERY_METHOD,
    DELIVERY_ADDRESS_UPDATE_FULFILLED,
    DELIVERY_ADDRESS_UPDATE_ERROR,
    DELIVERY_ADDRESS_UPDATE_PENDING,
    ACCOUNT_ALERT_UPDATE_ERROR,
    ACCOUNT_ALERT_UPDATE_FULFILLED,
    ACCOUNT_ALERT_UPDATE_PENDING,
    BANKING_ENABLE_ALERTS_FULFILLED,
    BANKING_ENABLE_ALERTS_PENDING,
    BANKING_ENABLE_ALERTS_ERROR,
    UPDATE_ALERT_BANKING_PENDING,
    UPDATE_ALERT_BANKING_FAILED,
    
} from '../actions/actionTypes'
import { LoadingState } from '../helpers/enum'

const initialState = {
    loadingState: LoadingState.PENDING,
    items: [],
    contactPreferenceState: LoadingState.PENDING,
    contactPreferences: [],
    deliveryMethodState: '',
    accountAlertState: '',
    bankingEnableAlertState: '',
    bankingAlertState: ''
}

export default function accountAlertsReducer(state = initialState, action) {

    switch (action.type) {

        case UPDATE_ALERT_BANKING_PENDING: {
            return {...state, bankingAlertState: LoadingState.PENDING}
        }
        case UPDATE_ALERT_BANKING_FAILED: {
            return {...state, bankingAlertState: LoadingState.FAILED}
        }
        case ACCOUNT_ALERT_UPDATE_FULFILLED:
            return { ...state, accountAlertState: '' }

        case ACCOUNT_ALERT_UPDATE_PENDING:
            return { ...state, accountAlertState: LoadingState.PENDING }

        case ACCOUNT_ALERT_UPDATE_ERROR:
            return { ...state, accountAlertState: '' }

        case DELIVERY_ADDRESS_UPDATE_FULFILLED:
            return { ...state, deliveryMethodState: '' }

        case DELIVERY_ADDRESS_UPDATE_PENDING:
            return { ...state, deliveryMethodState: LoadingState.PENDING }

        case DELIVERY_ADDRESS_UPDATE_ERROR:
            return { ...state, deliveryMethodState: '' }

        case BANKING_ENABLE_ALERTS_FULFILLED:
            return { ...state, bankingEnableAlertState: '' }

        case BANKING_ENABLE_ALERTS_PENDING:
            return { ...state, bankingEnableAlertState: LoadingState.PENDING }

        case BANKING_ENABLE_ALERTS_ERROR:
            return { ...state, bankingEnableAlertState: '' }

        case GET_ACCOUNT_ALERTS_PENDING:
            return {
                ...state,
                loadingState: LoadingState.PENDING
            }
        case GET_ACCOUNT_ALERTS_FAILED:
            return {
                ...state,
                loadingState: LoadingState.FAILED
            }
        case GET_ACCOUNT_ALERTS_FULFILLED:
            return {
                ...state,
                loadingState: LoadingState.FULFILLED,
                items: action.data
            }
        case GET_CONTACT_PREFERENCES_FULFILLED:
            return {
                ...state,
                contactPreferences: action.data,
                contactPreferenceState: LoadingState.FULFILLED
            }
        case UPDATE_ALERT_BANKING_FULFILLED: {
            return {
                ...state,
                items: {
                    ...state.items,
                    accounts: state.items.accounts.map(account => {
                        if (account.number === action.accountNumber) {
                            return { ...account, ...action.data }
                        } else if (action.data.isTextBankingDefault) {
                            return { ...account, isTextBankingDefault: false }
                        }
                        return account
                    })
                },
                bankingAlertState: LoadingState.FULFILLED
            }
        }
        case UPDATE_DELIVERY_METHOD:
            return {
                ...state,
                items: {
                    ...state.items,
                    deliveryMethods: state.items.deliveryMethods.map(deliveryMethod => {
                        if (deliveryMethod.id === action.data.id) {
                            return { ...deliveryMethod, ...action.data }
                        }
                        return { ...deliveryMethod }
                    })
                }
            }
        default:
            return state;
    }

}